import React from 'react'

import Typography from "@material-ui/core/Typography";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import mapStyle from "assets/jss/prehnit/components/mapStyle.jsx";

import { withNamespaces } from "react-i18next";

import { geoserverService } from "services/geoserver";

class LayerLegend extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      layerName: this.props.layer.layerName,
      rules : [],
      legend: <div></div>,
      image: undefined
    }

    this.parseRules = this.parseRules.bind(this);
  }

  legendEntry(color, text, kod, showCode) {
    const { classes } = this.props;
    return (
      <div className={classes.lengedEntry} key={kod}>
        <div className={classes.legendBox} style={{backgroundColor: color}}>&nbsp;</div>
        <Typography className={classes.legendText}>{text}{showCode === "1" ? <small className={classes.legendCode}> ({kod})</small> : null}</Typography>
      </div>
    );
  }

  parseRules(rules) {
    const { t, classes } = this.props;
    let entries = [];
    let ns = this.props.layer.dataCodeGroup;

    rules.forEach(function(rule) {
      if (rule.symbolizers[0].Polygon) {
        let color = rule.symbolizers[0].Polygon.fill;
        let kod = rule.name;
        if (kod) {
          entries.push(this.legendEntry(color, t(ns+":"+kod), kod, this.props.layer.showCode));
        }
      } else if (rule.symbolizers[0].Raster) {
        let colormap_entries = rule.symbolizers[0].Raster.colormap.entries
        colormap_entries.forEach(function(ce) {
          if (ce.label !== '') {
            entries.push(this.legendEntry(ce.color, t(ns+":"+ce.quantity), ce.quantity, this.props.layer.showCode))
          }
        }.bind(this));
      }

    }.bind(this));
    return (
      <div className={classes.legend}>
        {entries}
      </div>
    );

  }

  render() {

    if (this.state.layerName !== this.props.layer.layerName || this.state.rules.length === 0) {
      geoserverService.WMS.getLegendGraphic(this.props.layer.layerName)
      .then (data => {
        data = JSON.parse(data);

        if (data && data.Legend && Array.isArray(data.Legend) && data.Legend.length > 0 ) {
          let rules = data.Legend[0].rules;
          this.setState({
            rules: rules,
            layerName: this.props.layer.layerName
          });
        }

      });

    }

    let legend = this.parseRules(this.state.rules);
    return (
      <div>
        {legend}
      </div>
    );
  }
}

export default withNamespaces()(withStyles(mapStyle)(LayerLegend));